import React from 'react';
import { motion } from 'motion/react';

interface ToggleProps {
  active: boolean;
  onClick: () => void;
  color?: string;
  disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ active, onClick, color = 'bg-accent-primary', disabled }) => (
  <button 
    onClick={disabled ? undefined : onClick} 
    className={`w-11 h-6 rounded-full flex items-center p-0.5 transition-all shadow-inner border ${active ? color + ' border-white/30' : 'bg-zinc-800 border-white/10'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
  >
    <motion.div 
      initial={false}
      animate={{ 
        x: active ? 20 : 0,
        scale: active ? 1 : 0.95
      }}
      transition={{ type: "spring", stiffness: 600, damping: 35 }}
      className="w-5 h-5 bg-white rounded-full shadow-lg" 
    />
  </button>
);
